export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-GB": {
        "testResult": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Test result"])},
        "messagePass": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Congratulations you passed this exam, your result is:"])},
        "messageFail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We are sorry, you failed this test, your result is:"])},
        "reviewPass": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please review your answers."])},
        "reviewFail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please review your answers and try again."])},
        "task": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Task"])},
        "yourAnswer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your answer "])},
        "correct": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["correct"])},
        "wrong": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["wrong"])},
        "courses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Courses"])},
        "sources": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sources"])}
      },
      "nl-NL": {
        "testResult": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Testresultaat:"])},
        "messagePass": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gefeliciteerd, je hebt deze test gehaald, je resultaat is:"])},
        "messageFail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Helaas, je hebt deze test niet gehaald, je resultaat is:"])},
        "reviewPass": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Herzie alstublieft uw antwoorden"])},
        "reviewFail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Herzie alstublieft uw antwoorden en probeer opnieuw."])},
        "task": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Taak"])},
        "yourAnswer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uw antwoord "])},
        "correct": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["juist"])},
        "wrong": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["verkeerd"])},
        "courses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Curssusen"])},
        "sources": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bronnen"])}
      }
    }
  })
}
